import React, {useState} from "react";
import I18n from 'i18n.js.erb'
import {orderDetailSellerPDF} from "../../utils/PDFGEnerator/orderTemplate";
import {submissionListPDF} from "../../utils/PDFGEnerator/submissionListTemplate";
import { gradingPriceListTemplate } from "../../utils/PDFGEnerator/gradingPriceListTemplate";
import { shipmentAddressPDF } from "../../utils/PDFGEnerator/shipmentAddressTemplate";
import { submissionListsPDF } from "../../utils/PDFGEnerator/submissionListsTemplate";
import { blueprintImagesCompactPDF } from "../../utils/PDFGEnerator/blueprintImagesCompactTemplate";
import { blueprintImagesFullPDF } from "../../utils/PDFGEnerator/blueprintImagesFullTemplate";
import { voucherPDF } from "../../utils/PDFGEnerator/voucherTemplate";
import { vouchersPDF } from "../../utils/PDFGEnerator/vouchersTemplate";
import { encasingsPDF } from "../../utils/PDFGEnerator/encasingsTemplate";
import { submissionListFulfillmentPDF } from "../../utils/PDFGEnerator/submissionListFulfillTemplate";
import {isPresent} from "../../utils/utils";

const PDFGenerator = ({
  type,
  generatorText,
  cssClassList,
  dataToPrint,
  useTemplate,
  setShowErrorModal,
  environment,
  customIcon,
  customImageIcon,
  spinnerCssClassList,
  downloadMsgCssClassList,
  customComponentToRender,
  customComponentToRenderCssClass
}) => {

  const [loading, setLoading] = useState(false);


  // Funzione che permette di ottenere dal server il dettaglio completo e aggiornato di una submission list o di un
  // ordine, con tutte le informazioni che devono essere stampate nel pdf di riepilogo
  const getDataToPrintOnPDFFile = () => {
    setLoading(true)

    if (useTemplate === 'orderSeller' || useTemplate === 'orderBuyer') {
      const userType = useTemplate.toLowerCase().replace('order', '')
      let url = `/orders/${dataToPrint.id}/edit.json?page=1&per_page=${Number.MAX_SAFE_INTEGER}`

      fetch(url, {
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during getting data from database");
          else
            return response.json();
        })
        .then((data) => {
          orderDetailSellerPDF(data, userType)
          setLoading(false)
        })
        .catch((err) => {
          if (setShowErrorModal)
            setShowErrorModal(true)
          console.log(err);
          setLoading(false)
        });

    } else if (['submissionLists', 'influencersReport'].includes(useTemplate)) {
      let url = `${environment === 'backoffice' ? `/backoffice/companies/${dataToPrint.companyId}` : ''}/submission_lists.json?page=1&per_page=${Number.MAX_SAFE_INTEGER}&export_to_pdf=true`
      if (dataToPrint.userId)
        url += `&user_owner_id=${dataToPrint.userId}`
      Object.entries(dataToPrint.filters).forEach(([fieldName, fieldValue]) => {
        if (fieldValue !== null)
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during getting data from database");
          else
            return response.json();
        })
        .then((data) => {
          submissionListsPDF(data, dataToPrint.filters, dataToPrint.users, dataToPrint.graderCompanies, environment, dataToPrint.companyPoint, dataToPrint.isSuperMiddleman, useTemplate === 'influencersReport')
          setLoading(false)
        })
        .catch((err) => {
          if (setShowErrorModal)
            setShowErrorModal(true)
          console.log(err);
          setLoading(false)
        });

    } else if (useTemplate.indexOf('submissionList') > -1) {
      let url = `/submission_lists/${dataToPrint.submissionListInfo.id}.json?page=1&per_page=${Number.MAX_SAFE_INTEGER}`

      if (environment === 'backoffice')
        url = url + '?request_from=backoffice'

      fetch(url, {
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during getting data from database");
          else
            return response.json();
        })
        .then((data) => {
          submissionListPDF(data, dataToPrint.pricingFor)
          setLoading(false)
        })
        .catch((err) => {
          if (setShowErrorModal)
            setShowErrorModal(true)
          console.log(err);
          setLoading(false)
        });

    } else if (useTemplate.indexOf('blueprintImages') > -1) {
      let filters = dataToPrint.filters
      let url = `/backoffice/companies/${dataToPrint.companyId}/blueprint_images.json?export_to_pdf=true&page=1&per_page=${Number.MAX_SAFE_INTEGER.toString()}`

      Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        if (fieldName !== 'release_year' && fieldName !== 'release_month' && fieldName !== 'release_day')
          url += `&${fieldName}=${fieldValue}`
      })

      fetch(url, {
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during getting data from database");
          else
            return response.json();
        })
        .then((data) => {
          if (useTemplate === 'blueprintImagesFull')
            blueprintImagesFullPDF(data.blueprint_images_count, data.blueprint_images, filters, dataToPrint.available_options_for_select)
          else
            blueprintImagesCompactPDF(data.blueprint_images_count, data.blueprint_images, filters, dataToPrint.available_options_for_select)
          setLoading(false)
        })
        .catch((err) => {
          if (setShowErrorModal)
            setShowErrorModal(true)
          console.log(err);
          setLoading(false)
        });
    }

    else if (useTemplate === 'voucher') {
      voucherPDF(dataToPrint);
      setLoading(false)
    }

    else if (useTemplate === 'all_vouchers') {
      const url = `/backoffice/companies/${dataToPrint.companyId}/vouchers/all/update_all`;

      const body = {export_to_pdf: true}

      fetch(url + ".json", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during getting data from database");
          else
            return response.json();
        })
        .then((vouchers) => {
          const vouchersMatrix = []
          let vouchersArray = []

          for (const voucher of vouchers) {
            if (vouchersArray.length === 8) {
              vouchersMatrix.push(vouchersArray)
              vouchersArray = [];
            }
            vouchersArray.push(voucher)
          }
          vouchersMatrix.push(vouchersArray)
          vouchersPDF(vouchersMatrix);
          setLoading(false)
        })
        .catch((err) => {
          if (setShowErrorModal)
            setShowErrorModal(true)
          console.log(err);
          setLoading(false)
        });
    }

    else if (useTemplate === 'encasings') {
      const url = `/backoffice/companies/${dataToPrint.companyId}/submission_lists/encasings/all_encasings/${dataToPrint.submissionListId}`;

      fetch(url + ".json", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      })
        .then((response) => {
          if (!response.ok)
            throw Error("An error occour during getting data from database");
          else
            return response.json();
        })
        .then((encasings) => {
          encasingsPDF(encasings, dataToPrint.submissionListId.toString());
          setLoading(false)
        })
        .catch((err) => {
          if (setShowErrorModal)
            setShowErrorModal(true)
          console.log(err);
          setLoading(false)
        });
    }
  }
  


  // Funzione che genera il pdf stampandoci direttamente i dati senza chiederli al server
  const printPDFFile = () => {
    setLoading(true);
    if (useTemplate === 'gradingPriceList')
      gradingPriceListTemplate(dataToPrint)
    else if (useTemplate === 'shipmentAddress')
      shipmentAddressPDF(dataToPrint);
    else if (useTemplate === 'submissionListShipmentLabel')
        submissionListFulfillmentPDF(dataToPrint);
    setTimeout(() => setLoading(false), 500);
  }



  return (
    customComponentToRender ?
      <div className={isPresent(customComponentToRenderCssClass) ? customComponentToRenderCssClass : 'text-truncate'}
           onClick={(e) => {
             e.stopPropagation();
             getDataToPrintOnPDFFile();
           }}>
        {customComponentToRender}
      </div>
    :
      (
        type === 'button' ?
          <React.Fragment>
            {
              loading ?
                <div className={cssClassList}>
                  <div className="d-flex align-items-center text-center">
                    <div className={`spinner-border text-white ml-4 ${spinnerCssClassList ? spinnerCssClassList : ''}`} role="status"/>
                    <p className={`ml-2 text-nowrap text-white mb-0 ${downloadMsgCssClassList ? downloadMsgCssClassList : ''}`}>{I18n.t('js.PDFGenerator.submissionList.loadingData')}</p>
                  </div>
                </div>
              :
                <button
                  type="button"
                  className={cssClassList}
                  onClick={() => ['shipmentAddress', 'submissionListShipmentLabel'].includes(useTemplate) ? printPDFFile() : getDataToPrintOnPDFFile()}
                >
                  {
                    customImageIcon ?
                      <img src={customImageIcon} alt="" />
                    :
                      <i className={customIcon ? customIcon : "fas fa-file-download fa-lg"}/>
                  } &nbsp;
                  {generatorText}
                </button>
            }
          </React.Fragment>
        :
          <span
            className="text-aiBlue text-underline-imp cursor-pointer"
            onClick={() => printPDFFile()}
          >
            {generatorText}
          </span>
      )
    )
}

export default PDFGenerator;